import $axios from "@/api";

const groupUrl = "perusahaan/rekening"

const state = () => ({
    datas: [],
})

const mutations = {
    ASSIGN_DATA(state,payload){
        state.datas = payload
    },
}

const actions = {
    async listPerusahaanRekening({ commit }, filter) {
        try{
            const response =  await $axios.get(`${groupUrl}`,{params:filter})
            commit('ASSIGN_DATA',response.data.data)
        }catch(error){
            console.log(error)
        }
    },
    async storePerusahaanRekening({ commit, state}, payload) {
        try{
            const response =  await $axios.post(`${groupUrl}`,payload)  
            const updatedDatas = [...state.datas];
            updatedDatas.push(response.data.data);
            commit('ASSIGN_DATA',updatedDatas)
            return response
        }catch(error){
            console.log(error)
        }
    },
    async updatePerusahaanRekening({ commit, state }, payload) {
        try{
            const response =  await $axios.put(`${groupUrl}/${payload.id}`,payload)
            const updatedDatas = [...state.datas];
            const index = updatedDatas.findIndex(item => item.id === payload.id);
            if (index !== -1) {
                updatedDatas[index] = response.data.data;
                commit('ASSIGN_DATA', updatedDatas);
            }
            return response
        }catch(error){
            console.log(error)
        }
    },
    async deletePerusahaanRekening({ commit, state }, id) {
        try{
            const response =  await $axios.delete(`${groupUrl}/${id}`)
            const updatedDatas = state.datas.filter(item => item.id !== id);
            commit('ASSIGN_DATA',updatedDatas)
        }catch(error){
            console.log(error)
        }
    },
    
    


}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
